import React, { useEffect } from 'react' //, useCallback
import clsx from 'clsx'
import _ from 'lodash'
import useDimensions from 'react-cool-dimensions'
import styles from '../../GlobalComponents/GenericContainer/GenericContainer.module.scss'

export const ShippingModalTile = (props: any) => {
    let { resultTextFunc, pagerPosition = 'TOP' } = props
    const cardWidth = props.width
    const numCards = props.children ? props.children.length : 0
    const ref = React.useRef<HTMLDivElement | null>(null)
    const [offset, setOffset] = React.useState(0)
    useEffect(() => {
        setOffset(0)
        setCurrentSPage(1)
        ref.current && ref.current.scrollTo({ left: 0 })
    }, [props.resetKey])

    const [currentSPage, setCurrentSPage] = React.useState(1)
    const {
        observe,
        // unobserve,
        width,
        // height,
        // entry
    } = useDimensions({
        onResize: _.throttle(
            (
                {
                    // observe, unobserve, width, height, entry
                }
            ) => {
                setCurrentSPage(Math.floor(offset / pageSize) + 1)
                // unobserve(); // To stop observing the current target element
                // observe(); // To re-start observing the current target element
            },
            500
        ),
    })
    const pageSize = Math.max(Math.floor(width / cardWidth), 1)
    let maxPage = Math.ceil(numCards / pageSize)
    useEffect(() => {
        setOffset(0)
        setCurrentSPage(1)
        ref.current && ref.current.scrollTo({ left: 0 })
    }, [maxPage])
    // const currentPage =
    //     offset + pageSize >= numCards - 1 ? maxPage : Math.floor(offset / pageSize) + 1
    if (!isFinite(maxPage)) maxPage = 1
    const forwardClick = () => {
        if (ref.current) {
            let newOffset = Math.min(
                offset + Math.floor(width / cardWidth),
                numCards - Math.floor(width / cardWidth)
            )
            ref.current.scrollTo({ left: cardWidth * newOffset, behavior: 'smooth' })
            setOffset(newOffset)
            setCurrentSPage((cur) => Math.min(cur + 1, maxPage))
        }
    }
    const backwardClick = () => {
        if (ref.current) {
            let newOffset = Math.max(0, offset - Math.floor(width / cardWidth))
            ref.current.scrollTo({ left: cardWidth * newOffset, behavior: 'smooth' })
            setOffset(newOffset)
            setCurrentSPage((cur) => Math.max(cur - 1, 1))
        }
    }
    const numberClick = (pageNum: number) => {
        if (ref.current) {
            let newOffset = (pageNum - 1) * pageSize
            ref.current.scrollTo({ left: cardWidth * newOffset, behavior: 'smooth' })
            setOffset(newOffset)
            setCurrentSPage(pageNum)
        }
    }
    const getPageIndices = () => {
        if (maxPage < 10) return _.range(1, maxPage + 1)
        else {
            let pageSet = new Set<number>()
            pageSet.add(1)
            pageSet.add(maxPage)
            let pageRange = _.range(currentSPage - 3, currentSPage + 3)
            if (pageRange[0] < 1)
                pageRange = pageRange.map((val) => val + Math.abs(pageRange[0]) + 1)
            if (pageRange[5] > maxPage)
                pageRange = pageRange.map((val) => val - (pageRange[5] - maxPage))
            if (pageRange[0] === 1) {
                pageRange.push(Math.min(pageRange[5] + 1, maxPage))
                pageRange.push(Math.min(pageRange[5] + 2, maxPage))
            }
            if (pageRange[0] === 2) {
                pageRange.push(Math.min(pageRange[5] + 1, maxPage))
            }
            if (pageRange[5] === maxPage) {
                pageRange.push(Math.min(pageRange[0] - 1, maxPage))
                pageRange.push(Math.min(pageRange[0] - 2, maxPage))
            }
            if (pageRange[5] === maxPage - 1) {
                pageRange.push(Math.min(pageRange[0] - 1, maxPage))
            }
            pageRange.forEach((val) => pageSet.add(val))
            return Array.from(pageSet.values()).sort((a, b) => a - b)
        }
    }
    if (props.loading)
        return (
            <div className={'centered'}>
                <div className={'k-i-loading'} style={{ fontSize: 200, height: 580 }} />
            </div>
        )
    // 100 -> 100+
    let numCardsString = `${numCards === 100 ? numCards + '+' : numCards}`
    return (
        // apply display inline-block and max-width: 100% to this topLevelClassName to get pager to stick to right most card
        <div className={props.topLevelClassname}>
            {pagerPosition === 'BOTTOM' && (
                <div
                    className={styles.numResults}
                    style={{ marginRight: 5, marginBottom: 10 }}
                    test-dataid="genericContainerResults"
                >
                    {resultTextFunc
                        ? resultTextFunc(numCardsString)
                        : `${numCards} result${numCards !== 1 ? 's' : ''}`}
                </div>
            )}
            {pagerPosition === 'TOP' && (
                <div className={styles.controlsContainer}>
                    <div className={styles.numResults} style={{ marginRight: 5 }}>
                        {resultTextFunc
                            ? resultTextFunc(numCardsString)
                            : `${numCards} result${numCards !== 1 ? 's' : ''}`}
                    </div>
                    {getPageIndices().length > 1 && (
                        <>
                            <div
                                className={clsx(styles.leftButton, styles.button)}
                                onClick={backwardClick}
                                data-testid="accountSearchBackwardClick"
                            />
                            <div className={styles.numberButtonsContainer}>
                                {getPageIndices().map((row, i, arr) => {
                                    return (
                                        <>
                                            <div
                                                onClick={() => numberClick(row)}
                                                className={clsx([
                                                    styles.numberButton,
                                                    row === currentSPage && styles.selectedNumber,
                                                ])}
                                                data-testid="accountSearchPageNumber"
                                                key={i}
                                            >
                                                {row}
                                            </div>
                                            {i < arr.length - 1 && arr[i + 1] - arr[i] > 1 && (
                                                <div key="elip" className={styles.ellipsis}>
                                                    ...
                                                </div>
                                            )}
                                        </>
                                    )
                                })}
                            </div>
                            <div
                                className={clsx(styles.rightButton, styles.button)}
                                onClick={forwardClick}
                                data-testid="accountSearchForwardClick"
                            />
                        </>
                    )}
                </div>
            )}
            <div className={props.className}>
                <div
                    ref={(ele) => {
                        observe(ele)
                        ref.current = ele
                    }}
                    className={styles.innerContainer}
                >
                    {props.children}
                </div>
                {offset !== 0 && maxPage > 1 && (
                    <div
                        className={props.topLevelClassnameLeft}
                        style={{ pointerEvents: 'none' }}
                    />
                )}
                {offset !== numCards - Math.floor(width / cardWidth) && maxPage > 1 && (
                    <div
                        className={props.topLevelClassnameRight}
                        style={{ pointerEvents: 'none' }}
                    />
                )}
            </div>
            {pagerPosition === 'BOTTOM' && (
                <div
                    className={styles.controlsContainer}
                    style={{ marginRight: 'auto', marginTop: 10 }}
                >
                    {/* not updating class -- div for grid */}
                    <div></div>
                    {getPageIndices().length > 1 && (
                        <>
                            <div
                                className={clsx(styles.leftButton, styles.button)}
                                onClick={backwardClick}
                                data-testid="accountSearchBackwardClick"
                            />
                            <div className={styles.numberButtonsContainer}>
                                {getPageIndices().map((row, i, arr) => {
                                    return (
                                        <>
                                            <div
                                                onClick={() => numberClick(row)}
                                                className={clsx([
                                                    styles.numberButton,
                                                    row === currentSPage && styles.selectedNumber,
                                                ])}
                                                data-testid="accountSearchPageNumber"
                                                key={i}
                                            >
                                                {row}
                                            </div>
                                            {i < arr.length - 1 && arr[i + 1] - arr[i] > 1 && (
                                                <div key="elip" className={styles.ellipsis}>
                                                    ...
                                                </div>
                                            )}
                                        </>
                                    )
                                })}
                            </div>
                            <div
                                className={clsx(styles.rightButton, styles.button)}
                                onClick={forwardClick}
                                data-testid="accountSearchForwardClick"
                            />
                        </>
                    )}
                </div>
            )}
        </div>
    )
}
